module.exports = __webpack_public_path__ + "assets/img/slider-1.e1d91d4c.jpg";